import $ from 'jquery';
import 'slick-carousel';
import 'lightgallery';
import {Slider} from '../../js/librairies/slider/slider';
import {View360} from './view-360-int';

const SELECTOR_SHOW_360_OUTSIDE = '#show-360-outside';
const SELECTOR_SHOW_360_INSIDE = '#show-360-inside';
const SELECTOR_SHOW_PICTURES = '#show-pictures';
const SELECTOR_DIAPO = '.sliderDiapo';
const SELECTOR_360_OUTSIDE_CONTAINER = '#slider-360-outside';
const SELECTOR_360_INSIDE_CONTAINER = '#slider-360-inside';
const SELECTOR_360_OUTSIDE = '#slider-360-outside > div';
const SELECTOR_360_INSIDE = '#slider-360-inside > div';
const ROTATION = 1;
let view360Inside, view360Outside = null;

$(document).ready(function (){
    $(SELECTOR_DIAPO).not('.slick-initialized').slick({
        cssEase: 'ease-in-out',
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        swipe: true,
        draggable: false,
        asNavFor: '.sliderThumb',
        pauseOnHover: true,
        lazyLoad: 'ondemand'
    });

    initView360Outside();

    $(SELECTOR_SHOW_360_OUTSIDE).on('click', function () {
        show360Outside();
    });
    $(SELECTOR_SHOW_360_INSIDE).on('click', function () {
        show360Inside();
        initView360Inside();
    });

    $('.sliderThumb, #show-pictures').on('click', function () {
        showDiapo();
    });

    $('.toggleGalerie').click(function () {
        $('.slick-slide:not(.slick-cloned) .photoSlide').click();
    });
});

function show360Outside() {
    $(SELECTOR_SHOW_360_OUTSIDE).addClass('active');
    $(SELECTOR_SHOW_360_INSIDE).removeClass('active');
    $(SELECTOR_SHOW_PICTURES).removeClass('active');
    $(SELECTOR_DIAPO).hide();
    $(SELECTOR_360_INSIDE_CONTAINER).hide();
    $(SELECTOR_360_OUTSIDE_CONTAINER).show();
    if (view360Outside) {
        view360Outside.reset()
        view360Outside.play(ROTATION);
    }
}
function show360Inside() {
    $(SELECTOR_SHOW_360_INSIDE).addClass('active');
    $(SELECTOR_SHOW_360_OUTSIDE).removeClass('active');
    $(SELECTOR_SHOW_PICTURES).removeClass('active');
    $(SELECTOR_DIAPO).hide();
    $(SELECTOR_360_OUTSIDE_CONTAINER).hide();
    $(SELECTOR_360_INSIDE_CONTAINER).show();
    if (view360Outside) {
        view360Outside.pause();
    }
}

function showDiapo() {
    $(SELECTOR_SHOW_360_INSIDE).removeClass('active');
    $(SELECTOR_SHOW_360_OUTSIDE).removeClass('active');
    $(SELECTOR_SHOW_PICTURES).addClass('active');
    $(SELECTOR_360_OUTSIDE_CONTAINER).hide();
    $(SELECTOR_360_INSIDE_CONTAINER).hide();
    $(SELECTOR_DIAPO).show();
    $(SELECTOR_DIAPO).slick('refresh')
    if (view360Outside) {
        view360Outside.pause();
    }
    initLightGallery();
}

function initLightGallery() {
    $(SELECTOR_DIAPO).lightGallery({
        selector: '.photoSlide',
        cursor: 'crosshair',
        counter: false,
        autoplay: false,
        autoplayControls: false,
        download: false,
        fullScreen: true,
        exThumbImage: 'data-exthumbimage',
        enableSwipe: false
    });
}

function initView360Outside() {
    if (view360Outside) {
        return view360Outside;
    }
    if (document.querySelector(SELECTOR_360_OUTSIDE)) {
        view360Outside = new Slider(SELECTOR_360_OUTSIDE);
        view360Outside.prepare();
        view360Outside.on('loaded', function () {
            view360Outside.play(ROTATION);
        })
    } else {
        initLightGallery();
    }
}
function initView360Inside() {
    if (view360Inside) {
        return view360Inside;
    }
    const sliderDom = document.querySelector(SELECTOR_360_INSIDE_CONTAINER);
    view360Inside = new View360(SELECTOR_360_INSIDE);
    if (sliderDom.offsetHeight === 0) {
        view360Inside.setSize(sliderDom.offsetWidth, sliderDom.offsetWidth * 1080/1920);
    } else {
        view360Inside.setSize(sliderDom.offsetWidth, sliderDom.offsetHeight);
    }
    view360Inside.init();
}
